import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useCandidateDrawer } from "@/components/CandidateDrawer";
import { initials } from "@/lib/cc";
import { ClipboardCheck } from "lucide-react";

export default function OnboardingPage() {
  const [cands, setCands] = useState([]);
  const { open } = useCandidateDrawer();

  useEffect(() => {
    api.get("/candidates", { params: { stage: "onboarding" } }).then(({ data }) => setCands(data));
  }, []);

  return (
    <div className="fade-up">
      <div className="mb-6">
        <div className="label-eyebrow mb-2">Onboarding</div>
        <h1 className="font-display text-4xl font-bold flex items-center gap-3"><ClipboardCheck className="w-8 h-8" />Active Onboarding</h1>
        <p className="text-[var(--cc-text-soft)] mt-1">Candidates currently progressing through onboarding checklists.</p>
      </div>

      {cands.length === 0 && <div className="cc-card p-8 text-center text-[var(--cc-text-soft)]">No candidates in onboarding right now.</div>}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 stagger">
        {cands.map((c) => {
          const tasks = c.onboarding || [];
          const done = tasks.filter((t) => t.completed).length;
          const pct = tasks.length ? Math.round((done / tasks.length) * 100) : 0;
          const path = c.rtw?.nationality_status === "immigrant" ? "Immigrant" : "British";
          return (
            <div key={c.id} className="cc-card cc-card-hover p-6 cursor-pointer" onClick={() => open(c.id)} data-testid={`onboard-card-${c.id}`}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-bold"
                       style={{ background: "var(--cc-primary)" }}>{initials(c.first_name, c.last_name)}</div>
                  <div>
                    <div className="font-semibold">{c.first_name} {c.last_name}</div>
                    <div className="text-xs text-[var(--cc-text-soft)]">{c.job_title}</div>
                  </div>
                </div>
                <span className="pill pill-info">{path} path</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex-1">
                  <div className="cc-progress"><div className="cc-progress-fill" style={{ width: `${pct}%` }} /></div>
                </div>
                <div className="text-sm font-semibold whitespace-nowrap">{done}/{tasks.length} · {pct}%</div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-1 text-xs text-[var(--cc-text-soft)]">
                {tasks.slice(0, 6).map((t) => (
                  <div key={t.id} className={`flex items-center gap-1 ${t.completed ? "line-through opacity-60" : ""}`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${t.completed ? "bg-[var(--cc-success)]" : "bg-[var(--cc-border)]"}`}></span>
                    <span className="truncate">{t.label}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
